import { bunja } from 'bunja';
import { atom } from 'jotai';

import { positionOrderSort } from '@flipster/utils/sort';

import { spotOrdersAtom, type SpotPendingPosition } from './internal/fixed-topics/spot-order';
import { r230522SocketBunja } from './socket';

export type * from './internal/fixed-topics/spot-order';

/**
 * updated: 25/02/20
 * @see https://prextech.slack.com/archives/C0885FREU7Q/p1740029520015189?thread_ts=1739982915.087719&cid=C0885FREU7Q
 * spot-orders에 qty, amount 값을 모두 채워서 내려보내주기 때문에 calc하지 않고 소켓값을 그대로 바라보게끔 변경함
 * 추후 사용성 없다고 판단되면 제거할 것
 * cc.hoyong
 */
const pendingPositionsAtom = atom((get) => {
  const orders = get(spotOrdersAtom);
  if (!orders) return null;

  return Object.values(orders)
    .reduce((acc: SpotPendingPosition[], o) => {
      // amount = websocket:r230522/orders{symbol=String, slot=X}.amount
      // triggerPrice = websocket:r230522/orders{symbol=String, slot=X}.triggerPrice
      let orderType: 'qty' | 'amount';
      // 서버에서 amount 주문시 '0' 으로 내려주는 이슈 쉽게 수정안된다고 함
      if (Number(o.qty || '0') === 0) {
        orderType = 'amount';
      }
      if (Number(o.qty || '0') > 0) {
        orderType = 'qty';
      }
      acc.push({
        ...o,
        orderVolumeType: orderType!,
        qty: o.qty || '0',
        amount: o.amount || '0',
      });
      return acc;
    }, [])
    .sort(positionOrderSort)
    .reduce((acc: Record<string, SpotPendingPosition[]>, p) => {
      if (!acc[p.symbol]) acc[p.symbol] = []; // symbol이 없으면 초기화
      acc[p.symbol].push(p);
      return acc;
    }, {});
});
pendingPositionsAtom.debugLabel = 'pendingPositionsAtom';

export const spotOrdersBunja = bunja(() => {
  bunja.use(r230522SocketBunja);

  return { spotOrdersAtom, pendingPositionsAtom };
});
spotOrdersBunja.debugLabel = 'spotOrdersBunja';
